import { IonButton, IonButtons, IonContent, IonHeader, IonModal, IonTitle, IonToolbar } from "@ionic/react";
import React, { FC, ReactElement } from "react";

interface IProps {
    opened:boolean,
    setOpened:any,
    title:string|ReactElement,
    children:any,
    style?:any,
    onLoad?:any
    onDidDismiss?:()=>void
};

const AIModal:FC<IProps> = ({opened,setOpened,title,children,style,onLoad, onDidDismiss}) => {
    return <IonModal style={style}  isOpen={opened} onDidDismiss={onDidDismiss ? onDidDismiss : ()=>setOpened(false)} onDidPresent={onLoad ? onLoad : null}>
    <IonHeader className="bg-main">
        <IonToolbar className="bg-main">
          <IonTitle className="text-dark-blue">{title}</IonTitle>
          <IonButtons slot="end">
            <IonButton className="text-dark-blue" onClick={() => setOpened(false)}>x</IonButton>
          </IonButtons>
        </IonToolbar>
    </IonHeader>
    <IonContent class="ion-padding bg-main">
        {children}
    </IonContent>
    </IonModal>
};

export default AIModal;